import { Checkbox } from '../../../Checkbox'

import * as styles from './Control.module.css'

function Control({
  children,
  className = styles.Control,
  value,
  onChange,
  ...divProps
}) {
  function handleOmittedChange(checked) {
    onChange(value, { omitted: !checked })
  }

  return (
    <div {...divProps} className={className}>
      <div className={styles.label}>
        <Checkbox
          checked={!value.omitted}
          label={value.name}
          size='small'
          onChange={handleOmittedChange}
        />
      </div>
      <div className={styles.input}>{children}</div>
    </div>
  )
}

export default Control
